module.exports = __webpack_public_path__ + "ngrx.hw4GAw8m.png";